import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import {useEffect, useState} from "react";
import API from "../api/api";
import {Button, NavDropdown} from "react-bootstrap";
import {useNavigate} from "react-router-dom";

function CustomNavbar() {
    let username = localStorage.getItem('username');
    let password = localStorage.getItem('password');
    const [user, setUser] = useState(null);
    const [showDropDown, setShowDropDown] = useState(false);
    let url = window.location.pathname;
    const navigate = useNavigate();

    useEffect(() => {
        if (!username || !password) {
            return;
        }

        API.get("users/get-by-username?fetch-username=" + username, {
            headers: {
                username: username,
                password: password
            }
        }).then(response => {
            setUser(response.data);
        })
    }, []);


    function handleLogout(e) {
        localStorage.removeItem('username');
        localStorage.removeItem('password');
        window.location.reload();
    }

    return (
        <Navbar bg="black" expand="lg" data-bs-theme="dark">
            <Container>
                <Navbar.Brand href="/">
                    <img
                        src="https://storage.googleapis.com/milky-way-trail-website-storage/website-images/game_dev_logo-2.png" // Replace with your logo's path
                        alt="Logo"
                        height="60"
                        className="d-inline-block align-top"
                    />
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav"/>
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto" variant="underline" defaultActiveKey={url}>
                        <Nav.Link href="/about">About</Nav.Link>
                        <Nav.Link href="/games">Games</Nav.Link>
                        {/*<Nav.Link href="/events">Events</Nav.Link>*/}
                        {/*<Nav.Link href="/news">News</Nav.Link>*/}
                        {/*<Nav.Link href="/sponsors">Sponsors</Nav.Link>*/}
                    </Nav>

                    {!username && (
                        <Nav variant="underline" defaultActiveKey={url}>
                            <Nav.Link href="/login">Login</Nav.Link>
                            <Nav.Link href="/signup">Signup</Nav.Link>
                        </Nav>
                    )}
                    {username && (
                        <NavDropdown
                            show={showDropDown}
                            onMouseEnter={(e) => setShowDropDown(true)}
                            onMouseLeave={(e) => setShowDropDown(false)} title={
                            user && (
                                <img
                                    src={user.profile_picture_url} // Replace with your logo's path
                                    alt="Profile Picture"
                                    height="50"
                                    width="50"
                                    className="d-inline-block align-top rounded-circle ratio-1x1"
                                />
                            )}
                        >
                            <NavDropdown.Item onClick={(e) => {navigate("/users/" + username + "/profile")}}>
                                <Nav.Link>Profile</Nav.Link>
                            </NavDropdown.Item>
                            <NavDropdown.Divider/>
                            <NavDropdown.Item>
                                <Button className="bg-danger text-white border-0" onClick={handleLogout}>Logout</Button>
                            </NavDropdown.Item>

                        </NavDropdown>
                    )}
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

export default CustomNavbar;